import { NewEmailResult } from '../../../models/NewEmail'
import { User } from '../../../models/User'

const _NEW_EMAIL_NO_RESULT_VALUE = 'unknown'

export const isNewEmailNoResult = (newEmailResult: NewEmailResult | null) => {
  if (!newEmailResult) {
    return false
  }
  const { email } = newEmailResult
  return !email.length || email.toLowerCase() === _NEW_EMAIL_NO_RESULT_VALUE
}

export const hasClientRole = (user: User) => {
  const { roles } = user
  return roles.map((role) => role.name).includes('Client')
}
